<template>
  <div class="pwc-wrapper">
    <v-tabs v-model="active" color="#D04A02" slider-color="#FFB600" dark>
      <v-tab ripple> 已报名活动 </v-tab>
      <v-tab ripple> 待参加活动 </v-tab>
      <v-tab-item>
        <v-card flat class="pwc-event-list">
          <event-item
            v-for="e in registeredList"
            :key="e.id"
            :event="e"
            :go-detail="goDetail"
          />
          <no-data v-if="registeredList.length === 0" />
        </v-card>
      </v-tab-item>
      <v-tab-item>
        <v-card flat class="pwc-event-list">
          <event-item
            v-for="e in preparedList"
            :key="e.id"
            :event="e"
            :go-detail="goDetail"
          />
          <no-data v-if="preparedList.length === 0" />
        </v-card>
      </v-tab-item>
    </v-tabs>
  </div>
</template>

<script>
import EventItem from '../EventItem'
import NoData from '../../../NoData'

export default {
  components: {
    EventItem,
    NoData
  },
  props: {
    registeredList: {
      type: Array,
      default: () => []
    },
    preparedList: {
      type: Array,
      default: () => []
    },
    goDetail: {
      type: Function,
      default: () => {}
    }
  },
  data() {
    return {
      active: null
    }
  }
}
</script>

<style lang="scss" scoped>
.pwc-wrapper {
    margin: auto;
    .pwc-event-list {
        padding-left: 2px;
        padding-right: 2px;
    }
}
</style>
